import Vue from "vue";
import VueRouter from "vue-router";

import App from "./App.vue";
import { routes } from "./routes.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faSearch,
  faEdit,
  faUserPlus,
  faPlus,
  faEllipsisH,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { store } from "./store/store";

library.add(
  faUserSecret,
  faSearch,
  faEdit,
  faUserPlus,
  faPlus,
  faEllipsisH,
  faStar
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

import GAuth from "vue-google-oauth2";
const gauthOption = {
  clientId:
    "753657138996-sh8rslgoijenjrc51nde0fks15lfes1d.apps.googleusercontent.com",
  scope: "profile email",
  prompt: "select_account",
};
Vue.use(GAuth, gauthOption);

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
});

// this is a global to catch unlogged in users and point them straight to the login page thats all ...
router.beforeEach((to, from, next) => {
  // if expired go to login page
  const expiryDate = new Date(localStorage.getItem("djangoAccessTokenExpiry"));

  if (new Date() > expiryDate && to.path != "/login") {
    next({ name: "login" });
  }
  // if sign in user and not going to urls on the sign in paths
  else if (
    
    localStorage.getItem("userName") == "Signin User" && to.path.match(/signin/i) == null && to.path !="/login") {
    //eslint-disable-next-line no-console
    //console.log('to path', to.path);
    //eslint-disable-next-line no-console
    //console.log("logged in going to signin");
    next({ name: "signin" });
  }
  // everything else just go ....
  else {
    //eslint-disable-next-line no-console
    //console.log("logged in going to next");
    next();
  }
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
